import { useRef } from "react";
import {isEqual} from "lodash";

//pass in the fuction that returns the value, and the things you want to watch for deep changes
export function useDeepStableMemo<T>(factory: () => T, deps: any[], _label?: string): T {
    const valueRef = useRef<T | undefined>(undefined);
    const depsRef = useRef<string | undefined>(undefined);
    const strigifiedDeps = JSON.stringify(deps);
    // recompute only if deps deep-changed
    if (!depsRef.current || !isEqual(depsRef.current, strigifiedDeps)) {
        // whatChanged(depsRef.current, deps, label);
        const next = factory();
        // preserve previous reference if deep-equal -> prevents pointless updates
        if (!isEqual(valueRef.current, next)) {
            valueRef.current = next;
        }
        depsRef.current = strigifiedDeps;
    }

    return valueRef.current!;
}

export function whatChanged(obj1: any, obj2: any, label?: string) {
    const changes: string[] = [];
    const keys = new Set([...Object.keys(obj1 || {}), ...Object.keys(obj2 || {})]);
    keys.forEach(key => {
        if (!isEqual(obj1?.[key], obj2?.[key])) {
            changes.push(key);
        }
    });
    console.group(`Δ changes` + (label ? ` (${label})` : ''));
    if (changes.length === 0) {
        console.log("No changes");
    }
    changes.forEach(key => {
        console.log(`- ${key}`, { from: obj1?.[key], to: obj2?.[key] });
    });
    console.groupEnd();
}